import { GetB2bCampaignsPayoutsOneResponse } from '@Common/types/b2b/campaigns';
import {
  GetB2bCampaignAllocationOneResponse,
  GetB2bCampaignOneResponse,
} from '@Common/types/bo/b2b/campaigns';

export const campaignsTranslations = {
  'campaigns/payouts': {
    fields: {
      id: 'ID',
      b2b_campaign_id: 'ID Opération',
      b2b_company_id: 'ID Entreprise',
      b2b_employee_id: 'ID Adhérent',
      lastname: 'Nom',
      firstname: 'Prénom',
      savings_funds_request_id: 'ID Appel de fonds',
      created_at: 'Créé à',
      updated_at: 'Mis à jour à',
      user_currency_amount: 'Montant net',
      total_gross_amount: 'Montant brut',
      user_currency: 'Devise',
      tax_amount: 'Montant taxe',
      tax_info: 'Information taxe',
      status: 'Statut',
      payout_by: 'Règlement par',
      transfer_id: 'ID Virement',
      transfer_mdlr_status: 'Statut du virement',
      transfer_amount: 'Montant du virement',
      transfer_created_at: 'Virement créé le',
      transfer_executed_at: 'Virement exécuté le',
    } satisfies Record<keyof GetB2bCampaignsPayoutsOneResponse, string>,
    sections: { title: 'Paiement' },
  },
  campaigns: {
    fields: {
      id: 'ID Opération',
      company_id: 'ID Entreprise',
      b2b_contract_ids: 'IDs Contrat',
      b2b_contract_types: 'Type De Contrat',
      products: 'Couverture Produit',
      type: "Type d'opération",
      start_date: 'Date de début de la consultation',
      end_date: 'Date de fin de la consultation',
      from_created_at: 'Créé à partir de',
      to_created_at: 'Créé à',
      employees_count: 'Nombre de salariés éligibles',
      total_campaign_amount_gross: 'Montant total brut',
      total_campaign_amount_net: 'Montant total net de CSG/CRDS',
      total_entry_fee_amount: "Total droits d'entrée",
      total_net_invested_amount: 'Montant total net investi',
      total_net_amount: 'Montant total net (à payer)',
      total_gross_amount: 'Montant total brut à payer',
      status: 'Statut',
      savings_funds_request_id: 'ID Appel de fonds',
      created_at: 'Créé le',
      updated_at: 'Mis à jour à',
      payment_method: 'Méthode de paiement',
      matching_contribution_related_cash_source: 'Related cash source',
      matching_contribution_related_cash_source_input: 'Related cash source',
      related_campaign_id: 'Campagne associée',
      choice_collected_by: 'Collecte des choix par',
      payout_by: 'Règlements immédiats par',
      allocation_computed_by: 'Calcul des quotes-parts par',
      fiscal_period_start: 'Date de début de la période de référence',
      fiscal_period_end: 'Date de fin de la période de référence',
      reason: "Motif de l'opération",
      reference_year: 'Année de référence',
      amount_type_input: 'Type de montant',
      value_sharing_bonus_fiscal_rule: 'Règle fiscale Prime de Partage de la Valeur',
      is_draft: 'Est un brouillon',
      is_cancelled: 'Est annulé',
      amount_input: 'Montant',
      is_late_payment_interests: 'Montants des intérêts de retard',
      is_emails_enabled: "Emails de l'opération activés",
      distribution_rule_file_url: 'Fichier de règles de distribution',
      allocation_file_url: "Fichier d'allocations",
      late_payment_interests_override_amount: 'Montant des intérêts de retard auto-calculé',
      total_matching_contribution_amount: 'Abondement net',
      total_matching_contribution_amount_gross: 'Abondement brut',
      total_matching_contribution_entry_fee_amount: "Droits d'entrée d'abondement",
      total_matching_contribution_net_invested_amount: 'Abondement net investi',
      matching_contribution_computed_by: 'Abondement calculé par',
      reference_period: 'Période de référence',
      target_fund_request_date: 'Date de demande de fonds',
      target_nav_date: 'Date de VL (Valeur Liquidative)',
      target_payment_date: 'Date de paiement (Prélèvement SEPA ou Virement)',
      group_operation_gross_amount: "Montant brut de l'opération de groupe",
    } satisfies Record<keyof GetB2bCampaignOneResponse & 'reference_period', string>,
  },
  'campaigns/allocations': {
    fields: {
      id: 'ID allocation',
      campaign_id: 'ID Opération',
      employee_id: 'ID Adhérent',
      firstname: 'Prénom',
      lastname: 'Nom',
      identifier: 'Identifiant',
      registration_number: 'Matricule',
      net_amount: 'Montant net de CSG/CRDS',
      net_amount_deposit: 'Montant net du versement',
      gross_amount: 'Montant brut',
      entry_fee_amount: "Droits d'entrée",
      net_invested_amount: 'Montant net investi',
      invested_amount: 'Montant investi (net de CSG/CRDS)',
      matching_contribution_amount: 'Montant abondement (brut)',
      payout_amount: 'Montant perçu immédiatement',
      late_interests_amount: 'Intérêts de retard (brut)',
      amount_in_days: 'Total jours',
      cet_days: 'Jours Divers',
      rtt_days: 'Jours RTT',
      overtime_days: 'Jours heures supplémentaires',
      paid_leave_days: 'Jours congés payés',
      seniority_leave_days: "Jours congés d'ancienneté",
      untaken_rest_days: 'Jours de repos non pris',
      invested_amount_in_days: 'Jours investis',
      invested_cet_days: 'Jours Divers investis',
      invested_rtt_days: 'Jours RTT investis',
      invested_overtime_days: 'Jours heures supplémentaires investis',
      invested_paid_leave_days: 'Jours congés payés investis',
      invested_seniority_leave_days: "Jours congés d'ancienneté investis",
      invested_untaken_rest_days: 'Jours de repos non pris investis',
      csg_amount: 'Montant CSG',
      crds_amount: 'Montant CRDS',
      company_id: 'ID Entreprise',
      social_status: 'Statut social',
      tax_residence_code: 'Code de résidence fiscale',
      company_collected_choices: 'Collecte des choix par l’entreprise',
    } satisfies Record<keyof GetB2bCampaignAllocationOneResponse & 'net_amount_deposit', string>,
    label: 'Répartition par salariés ayant-droits',
  },
  'campaigns/employees_awaiting_response': {
    fields: {
      id: "ID d'employé",
      firstname: 'Prénom',
      lastname: 'Nom de famille',
    },
    label: "Les employés qui n'ont pas encore fait de choix",
  },
};
